export const devOsViewSample = {
    'summary': 'Notification limit usage exceeded',
    'event_id': '129335065553',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2022-10-04 10:58:00+09:00',
    'metric_name': 'limits.cpu',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'cpu',
    'event_type': 'INFO',
    'custom_details': {
        'ping time': '1500ms',
        'load avg': '0.75'
    }
};

export const devOsSample = {
    'summary': 'Notification limit usage exceeded',
    'event_id': '129335065553',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2022-10-04 10:58:00+09:00',
    'metric_name': 'limits.cpu',
    'threshold': '90',
    'metric_value': '93.1',
    'resource_name': 'cpu',
    'event_type': 'INFO',
    'custom_details': {
        'ping time': '1500ms',
        'load avg': '0.75'
    }
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/devos.ts